(function(){
  /* Cart reward celebration (confetti + card). Sound removed. Only fires when the customer adds items and crosses a reward level, never on page load or when a discount code changes the total. */
  var LV=[
    {a:69900,e:'🚚',t:'Free Shipping unlocked!',s:'You just saved ₹110 on shipping'},
    {a:149900,e:'🎉',t:'20% OFF unlocked!',s:'Extra discount applied to your cart'},
    {a:249900,e:'🎁',t:'Free Ixora Plant unlocked!',s:'Your free gift is in your cart'}
  ], prev=null, prevCount=null;

  function confetti(){
    var c=document.createElement('canvas');
    c.style.cssText='position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:999999';
    c.width=innerWidth;c.height=innerHeight;
    document.body.appendChild(c);
    var x=c.getContext('2d'),cols=['#2E7D32','#8BC34A','#FFC107','#E91E63','#03A9F4','#FF5722'],p=[];
    for(var i=0;i<110;i++){
      var a=-Math.PI/2+(Math.random()-0.5)*1.6,v=9+Math.random()*10;
      p.push({x:c.width/2,y:c.height*0.75,vx:Math.cos(a)*v,vy:Math.sin(a)*v,
        w:6+Math.random()*6,h:8+Math.random()*8,r:Math.random()*6,vr:(Math.random()-0.5)*0.4,
        c:cols[i%cols.length]});
    }
    var st=Date.now();
    (function f(){
      var el=Date.now()-st;
      x.clearRect(0,0,c.width,c.height);
      p.forEach(function(q){
        q.vy+=0.35;q.vx*=0.99;q.x+=q.vx;q.y+=q.vy;q.r+=q.vr;
        x.save();x.translate(q.x,q.y);x.rotate(q.r);
        x.globalAlpha=Math.max(0,1-el/2400);
        x.fillStyle=q.c;x.fillRect(-q.w/2,-q.h/2,q.w,q.h);x.restore();
      });
      if(el<2400) requestAnimationFrame(f); else c.remove();
    })();
  }

  function card(l){
    var d=document.createElement('div');
    d.style.cssText='position:fixed;left:50%;bottom:-140px;transform:translateX(-50%);width:calc(100% - 32px);max-width:420px;'
      +'background:linear-gradient(135deg,#1B5E20,#43A047);color:#fff;border-radius:18px;padding:16px 18px;'
      +'display:flex;align-items:center;gap:14px;box-shadow:0 12px 32px rgba(0,0,0,.35);z-index:999998;'
      +'transition:bottom .5s cubic-bezier(.2,1.4,.4,1);font-family:inherit';
    d.innerHTML='<div style="font-size:38px;line-height:1">'+l.e+'</div>'
      +'<div><div style="font-size:17px;font-weight:700">'+l.t+'</div>'
      +'<div style="font-size:13px;opacity:.9;margin-top:2px">'+l.s+'</div></div>';
    document.body.appendChild(d);
    setTimeout(function(){d.style.bottom='24px';},30);
    setTimeout(function(){d.style.bottom='-140px';},3600);
    setTimeout(function(){d.remove();},4300);
  }

  function celebrate(l){
    confetti();card(l);
  }

  function check(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      var t=c.total_price, n=c.item_count;
      if(prev!==null && prevCount!==null && n>prevCount){
        for(var i=LV.length-1;i>=0;i--){
          if(prev<LV[i].a&&t>=LV[i].a){celebrate(LV[i]);break;}
        }
      }
      prev=t;prevCount=n;
    }).catch(function(){});
  }
  check();
  setInterval(check,1500);
})();
